<template>
  <div class="popup_wrap">
    <span class="ticket_btnbox">
      <span class="checkbox" @click="mustRead">
        <input type="checkbox" id="agree-checkbox" v-model="inputVal" />
        <label for="agree-checkbox">예약안내 및 유의사항 동의[필수]</label>
      </span>
      <a class="openPopup" @click="openModal">전문보기</a>
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="예약안내 및 유의사항 동의">
      <!-- default 슬롯 콘텐츠 -->
      <ReserveInfoText />
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap tcen agree_btn">
          <a class="wdhalf btn btn_bg gray" @click="() => onButtonClick(false)">비동의</a>
          <a class="wdhalf btn btn_bg color" @click="() => onButtonClick(true)">동의</a>
        </div>
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import ReserveInfoText from '@/components/popup/ReserveInfoText.vue';

export default {
  components: { Modal, ReserveInfoText },
  props: ['value'],
  data() {
    return {
      modal: {
        open: false,
      },
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        if (!this.modal.open && val === true) {
          this.$emit('input', false);
          this.modal.open = true;
        } else {
          this.$emit('input', val);
        }
      },
    },
  },
  watch: {},
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    mustRead(e) {
      if (!this.value) {
        e.stopPropagation();
        e.preventDefault();
        this.modal.open = true;
      }
    },
    onButtonClick(agree) {
      this.$emit('input', agree);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }
}
@media (max-width: 540px) {
  .btn_wrap.agree_btn .btn.wdhalf {
    min-width: min-content;
    width: 50%;
    margin: 0 0 1px 0;
  }
}
</style>
